// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('resellerorder.manageorders', {
        url: '/fulfill/manage/orders',
        templateUrl: 'main/resellerorder/resellerorderfulfillment/manageorders/manageorders.tpl.html',
        controller: 'ResellerOrderManageOrdersController as vm',
        resolve: {},
        params: {
            orderId: undefined,
            productNumber: undefined,
            usingScannerNavigation: false
        }
    });
}

// @ngInject
function ResellerOrderManageOrdersController($rootScope, $state, $translate, $scope, $window, $stateParams, ResellerOrdersApiService, loadSpinnerService, ToasterService, printLanguageConfirmationDialogService) {
    var vm = this;

    //Properties
    vm.canAccess = $rootScope.canAccess;
    vm.selectedFulfilledOrdersWarehouse = {};
    vm.fulfilledOrders = [];
    vm.filteredFulfilledOrders = [];
    vm.fulfilledOrdersFilter = '';
    vm.pageSizes = [
        { id: 0, val: 5 },
        { id: 1, val: 10 },
        { id: 2, val: 20 },
        { id: 3, val: 50 },
        { id: 4, val: 100 },
        { id: 5, val: 200 }
    ];
    vm.selectedPageSize = vm.pageSizes[4];
    vm.openCheck = true;
    vm.closedCheck = true;
    vm.filterPickPrinted = false;
    vm.filterDeliveryPrinted = false;
    vm.monthDates = [
        { id: 0, val: 1 },
        { id: 1, val: 3 },
        { id: 2, val: 6 },
        { id: 3, val: 9 },
        { id: 4, val: 12 },
        { id: 5, val: 18 }
    ];
    vm.selectedDateMonth = vm.monthDates[1];

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.onSelectProduct = onSelectProduct;
    vm.toggleExpandAll = toggleExpandAll;
    vm.printResellerOrder = printResellerOrder;
    vm.printResellerOrderPickingList = printResellerOrderPickingList;
    vm.getResellerOrderDeliveryNotePdf = getResellerOrderDeliveryNotePdf;
    vm.goToOrder = goToOrder;
    vm.goToProduct = goToProduct;
    vm.printAllResellerOrderPickingLists = printAllResellerOrderPickingLists;
    vm.filterFulfilledOrders = filterFulfilledOrders;
    vm.hasBeenPrinted = hasBeenPrinted;
    vm.getLatestPrint = getLatestPrint;
    vm.canPick = canPick;
    vm.confirmPicking = confirmPicking;
    vm.canPickAll = canPickAll;
    vm.confirmPickAll = confirmPickAll;
    vm.toggleClosePicking = toggleClosePicking;
    vm.canPrintDeliveryNote = canPrintDeliveryNote;
    vm.loadFulfilledOrders = loadFulfilledOrders;

    // Scanner navigation parameters
    vm.orderId = $stateParams.orderId;
    vm.productNumber = $stateParams.productNumber;
    vm.usingScannerNavigation = $stateParams.productNumber;

    activate();

    function activate() {
        $scope.$watch(function () { return vm.selectedFulfilledOrdersWarehouse.id; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                loadFulfilledOrders();
                saveLastUsedFulfilledOrdersWarehouseId(newValue);
            }
        });
        $scope.$watch(function () { return vm.selectedPageSize.id; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                loadFulfilledOrders();
            }
        });
        $scope.$watch(function () { return vm.selectedDateMonth.id; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                loadFulfilledOrders();
            }
        });
        if (vm.orderId && vm.usingScannerNavigation) {
            expandOrder(vm.orderId);
        }
    }

    function onInit() {
        ResellerOrdersApiService.getWarehouses().then(function (response) {
            vm.warehouses = response.warehouses;
            var lastUsedFulfilledOrdersWarehouseId = getLastUsedFulfilledOrdersWarehouseId();
            vm.selectedFulfilledOrdersWarehouse = _.find(vm.warehouses, function (o) { return o.id === lastUsedFulfilledOrdersWarehouseId; });
        }, function (error) {
            ToasterService.showError(error.message);
        });
    }
    function onChanges() {
    }

    function canPick(lineItem) {
        return hasLink(lineItem.links, 'canPick');
    }
    function canPickAll(order) {
        var canPick = false;
        _.forEach(order.fulfillmentLineItems, function(li) {
            if (hasLink(li.links, 'canPick')) {
                canPick = true;
            }
        });

        return canPick;
    }
    function confirmPicking(lineItem) {
        if (canPick(lineItem)) {
            var request = {
                pickingConfirmations: [{
                    fulfillmentLineItemId: lineItem.id,
                    pickedQuantity: lineItem.pickableQuantity,
                    closePicking: lineItem.closePicking
                }]
            };

            ResellerOrdersApiService.confirmFulfillmentLineItemPicking(request).then(function (response) {
                var lineItemEvent = _.find(response.events, function(o) {
                    return o.id === lineItem.id;
                });
                lineItem.links = lineItemEvent.links;

                lineItem.pickableQuantity = lineItemEvent.pickableQuantity;
                lineItem.pickedQuantity = lineItemEvent.pickedQuantity;
            }, function (error) {
                ToasterService.showError(error.message);
            });
        }
    }
    function confirmPickAll(order) {
        var request = {
            pickingConfirmations: []
        };
        _.forEach(order.fulfillmentLineItems, function(lineItem) {
            if (canPick(lineItem)) {
                request.pickingConfirmations.push({
                    fulfillmentLineItemId: lineItem.id,
                    pickedQuantity: lineItem.pickableQuantity,
                    closePicking: lineItem.closePicking ? lineItem.closePicking : false
                });
            }
        });

        ResellerOrdersApiService.confirmFulfillmentLineItemPicking(request).then(function (response) {
            _.forEach(response.events, function(ev) {
                var lineItem = _.find(order.fulfillmentLineItems, function(o) {
                    return o.id === ev.id;
                });
                if (lineItem) {
                    lineItem.links = ev.links;

                    lineItem.pickableQuantity = ev.pickableQuantity;
                    lineItem.pickedQuantity = ev.pickedQuantity;
                }
            });
        }, function (error) {
            ToasterService.showError(error.message);
        });
    }
    function toggleClosePicking(order) {
        var allAreTrue = true;
        _.forEach(order.fulfillmentLineItems, function (li) {
            if (!li.closePicking || li.closePicking === false) {
                allAreTrue = false;
            }
        });

        _.forEach(order.fulfillmentLineItems, function (li) {
            if (!allAreTrue) {
                li.closePicking = true;
                order.closeAllPickings = true;
            } else {
                li.closePicking = false;
                order.closeAllPickings = false;
            }
        });
    }

    function hasLink(links, rel) {
        var link = _.find(links, function (o) {
            return o.rel === rel;
        });

        if (link) {
            return true;
        }

        return false;
    }

    function getLatestPrint(order, type) {
        if (order.printLog.length > 0) {
            var listOfType = _.last(_.filter(order.printLog, function(log){return log.type === type}));

            if(listOfType){
                return $translate.instant('resellerorder.hasBeenPrinted') + ': ' +
                    formatDate(new Date(listOfType.dateUTC)) + ' ' +
                    $translate.instant('resellerorder.hasBeenPrintedBy') + ' ' + listOfType.user;
            }
        }
        return '';
    }
    function hasBeenPrinted(order, type) {

        return _.find(order.printLog, function(log){return log.type === type;});

        //return order.printLog.length > 0;
    }
    function formatDate(date) {
        if (!date) { return ''; }
        return date.getFullYear() + '-' + zeroFill(date.getMonth() + 1, 2) + '-' + zeroFill(date.getDate(), 2);
    }
    function zeroFill(number, width)
    {
        width -= number.toString().length;
        if (width > 0)
        {
            return new Array(width + ((/\./).test(number) ? 2 : 1)).join('0') + number;
        }
        return number + ''; // always return a string
    }

    function filterFulfilledOrders() {
        console.log('fulfilledOrdersFilter: "' + vm.fulfilledOrdersFilter + '"');

        if (vm.fulfilledOrdersFilter.trim().length > 0) {
            var searchTerm = vm.fulfilledOrdersFilter.trim().toLowerCase();
            vm.filteredFulfilledOrders = _.filter(vm.fulfilledOrders, function(o) {
                return o.orderNumber.toLowerCase().indexOf(searchTerm) > -1 ||
                        o.resellerName.toLowerCase().indexOf(searchTerm) > -1;
            });
        } else {
            vm.filteredFulfilledOrders = vm.fulfilledOrders;
        }

        vm.filteredFulfilledOrders = _.filter(vm.filteredFulfilledOrders, function(order){
            if(order.printLog.length > 0){
                if(vm.filterPickPrinted && !vm.filterDeliveryPrinted){
                    return _.find(order.printLog, function(log){return log.type === 'ResellerOrderPickingList'});
                }
                else if(vm.filterDeliveryPrinted && !vm.filterPickPrinted){
                    return _.find(order.printLog, function(log){return log.type === 'ResellerOrderDeliveryNote'});
                }
                else if(vm.filterDeliveryPrinted && vm.filterPickPrinted){
                    return _.find(order.printLog, function(log){return log.type === 'ResellerOrderPickingList' || log.type === 'ResellerOrderDeliveryNote'});
                }
            }
            else if(!vm.filterDeliveryPrinted && !vm.filterPickPrinted) {
                return order;
            }
        });
    }

    function canPrintDeliveryNote(order){
        var isAnyPicked = false;
        if(order !== null){
            _.forEach(order.fulfillmentLineItems, function(lineItem){
                if(lineItem.pickedQuantity > 0)
                    isAnyPicked = true;
            });
        }
        return isAnyPicked;
    }

    function goToOrder(orderId) {
        var url = $state.href('resellerorder.resellerorderview', {orderId: orderId});
        $window.open(url,'_blank');
    }
    function goToProduct(articleId) {
        var url = $state.href('product.articles.article', {articleId: articleId});
        $window.open(url,'_blank');
    }

    function printAllResellerOrderPickingLists() {
        printLanguageConfirmationDialogService.showDialog($translate.instant('common.printAll') + '?').then(function (result) {
            if (result.result === true) {
                loadSpinnerService.start('mainSpinner');
                var request = {
                    resellerOrderIds: [],
                    locale: result.locale
                };
                _.forEach(vm.fulfilledOrders, function(o) { request.resellerOrderIds.push(o.id); });

                ResellerOrdersApiService.getResellerOrderOrderPerspectivePickingList(request).then(function (response) {
                }, function (error) {
                    ToasterService.showError(error.message);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function printResellerOrder(orderId) {
        loadSpinnerService.start('mainSpinner');
        ResellerOrdersApiService.getResellerOrderPdf(orderId).then(function (response) {
        }, function (error) {
            ToasterService.showError(error.message);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }
    function printResellerOrderPickingList(orderId) {
        printLanguageConfirmationDialogService.showDialog($translate.instant('order.print.pickingList') + '?').then(function (result) {
            if (result.result === true) {
                loadSpinnerService.start('mainSpinner');
                var request = {
                    resellerOrderIds: [orderId],
                    locale: result.locale
                };
                ResellerOrdersApiService.getResellerOrderOrderPerspectivePickingList(request).then(function (response) {
                }, function (error) {
                    ToasterService.showError(error.message);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }
    function getResellerOrderDeliveryNotePdf(orderId) {
        printLanguageConfirmationDialogService.showDialog($translate.instant('order.printdisplayed') + '?').then(function (result) {
            if (result.result === true) {
                var request = {
                    resellerOrderIds: [orderId],
                    locale: result.locale
                };
                loadSpinnerService.start('mainSpinner');

                ResellerOrdersApiService.getResellerOrderDeliveryNote(request).then(function (response) {
                }, function (error) {
                    ToasterService.showError(error.message);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function getLastUsedFulfilledOrdersWarehouseId() {
        if ($window.localStorage.resellerorderfulfill_lastUsedFulfilledOrdersWarehouseId) {
            var lastUsedFulfilledOrdersWarehouseId = parseInt($window.localStorage.getItem('resellerorderfulfill_lastUsedFulfilledOrdersWarehouseId'));
            if (isNaN(lastUsedFulfilledOrdersWarehouseId)) { return undefined; }
            return lastUsedFulfilledOrdersWarehouseId;
        }
        return undefined;
    }
    function saveLastUsedFulfilledOrdersWarehouseId(id) {
        $window.localStorage.setItem('resellerorderfulfill_lastUsedFulfilledOrdersWarehouseId', id);
    }

    function toggleExpandAll() {
        var allAreExpanded = true;
        _.forEach(vm.fulfilledOrders, function (ord) {
            if (!ord.showOrderVariants || ord.showOrderVariants === false) {
                allAreExpanded = false;
            }
        });

        _.forEach(vm.fulfilledOrders, function (ord) {
            if (!allAreExpanded) {
                ord.showOrderVariants = true;
            } else {
                ord.showOrderVariants = false;
            }
        });
    }

    function loadFulfilledOrders() {
        if (true) {
            loadSpinnerService.start('mainSpinner');
            var request = {
                warehouseId: vm.selectedFulfilledOrdersWarehouse.id,
                pageSize: vm.selectedPageSize.val,
                filterOpen : vm.openCheck,
                filterClosed : vm.closedCheck,
                filterDateMonth : vm.selectedDateMonth.val
            };
            ResellerOrdersApiService.getFulfilledOrders(request).then(function (response) {
                vm.fulfilledOrders = response.data.orders;

                _.forEach(vm.fulfilledOrders, function (o) {
                    o.showOrderVariants = false;
                });

                //Sort on ordernumber
                vm.fulfilledOrders = _.orderBy(vm.fulfilledOrders, ['createdDate'], ['desc']);

                //Copy to filter list
                vm.filteredFulfilledOrders = angular.copy(vm.fulfilledOrders);

                filterFulfilledOrders();

                if (vm.orderId && vm.usingScannerNavigation) {
                    expandOrder(vm.orderId);
                }

                console.log(vm.fulfilledOrders);
            }, function (error) {
                console.log(error);
            }).then(function () {
                loadSpinnerService.stop('mainSpinner');
            });
        }
    }

    function onSelectProduct(product) {
        if (!product || !product.articleId || product.articleId <= 0) { return; }

        product.showOrderVariants = true;
    }

    function expandOrder(orderId) {
        var order = _.find(vm.filteredFulfilledOrders, function(order) {
            return order.id === orderId;
        });

        if (order) {
            order.showOrderVariants = true;
        }
    }
}

angular
    .module('resellerorder.manageorders', [])
    .config(stateConfig)
    .controller('ResellerOrderManageOrdersController', ResellerOrderManageOrdersController);
